import * as types from './types';

export default {
  /* eslint-disable no-param-reassign */

  /**
   * Mutation to check if the user is authenticated.
   *
   * @param {Object} state The current state of the store.
   */
  [types.CHECK](state) {
    state.authenticated = !!localStorage.getItem('session');
    if (state.authenticated) {
      const session = JSON.parse(localStorage.getItem('session'));
      state.userInfo.features = session.features;
      state.userInfo.login = session.login;
      state.userInfo.orgId = session.orgId;
      state.userInfo.token = session.token;
    }
  },

  /**
   * Mutation to log the user out.
   *
   * @param {Object} state The current state of the store.
   */
  [types.LOGOUT](state) {
    state.authenticated = false;
    state.userInfo.features = [];
    state.userInfo.login = undefined;
    state.userInfo.orgId = undefined;
    state.userInfo.token = undefined;
  },

  [types.LOAD_INFOS](state, infos) {
    state.infos = infos;
  },

  [types.AUTHENTIFICATION_SUCCESS](state) {
    state.authenticated = true;
    try {
      const session = JSON.parse(localStorage.getItem('session'));
      state.userInfo.features = session.features;
      state.userInfo.login = session.login;
      state.userInfo.orgId = session.orgId;
      state.userInfo.token = session.token;
    } catch (e) {
      console.log(e);
    }
  },

  [types.AUTHENTIFICATION_FAILED](state) {
    state.authenticated = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js